/**
 * GMOかんたんゲームボックス連携ユーティリティ
 */

declare global {
  interface Window {
    game_start?: (options: { callback: string | (() => void) }) => void;
    game_end?: (options: { callback: string | (() => void); score: number }) => void;
  }
}

/**
 * ゲーム開始APIを呼び出す
 */
export function callGameStart(callback: () => void): void {
  if (typeof window.game_start === 'function') {
    window.game_start({ callback });
  } else {
    // 開発環境: 即座にコールバックを呼ぶ
    console.warn('game_start API not found, calling callback immediately');
    setTimeout(callback, 100);
  }
}

/**
 * ゲーム終了APIを呼び出す
 */
export function callGameEnd(score: number, callback: () => void): void {
  if (typeof window.game_end === 'function') {
    window.game_end({ callback, score });
  } else {
    // 開発環境: 即座にコールバックを呼ぶ
    console.warn('game_end API not found, calling callback immediately');
    setTimeout(callback, 100);
  }
}


